import {useMemo} from 'react'
import {useFirebaseUser} from 'utils'
import {useSelector} from 'lib/redux'

export function useFirestoreEditCredentialKycStatus() {
  const {id} = useSelector('user') || {}
  const userData = useFirebaseUser({id: id || ''}).data

  const verificationStatus = useMemo(
    () =>
      id
        ? {
            verification_email_status: userData
              ? userData.verification_email_status
              : undefined,
            verification_phone_status: userData
              ? userData.verification_phone_status
              : undefined,
          }
        : {
            verification_email_status: undefined,
            verification_phone_status: undefined,
          },
    [id, userData],
  )

  return verificationStatus
}
